import axios from 'axios';

const token = localStorage.getItem('user-token');
const api_url = process.env.VUE_APP_API_VIDA_URL;

export default {
  async getInsuredById(insuredId) {
    try {
      const response = await axios.get(`${api_url}/insureds/${insuredId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async revealInsuredField(insuredId, field, proposalId) {
    try {
      const response = await axios.post(
        `${api_url}/insureds/${insuredId}/reveal`,
        { field, proposalId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getInsuredVehicles(insuredId) {
    try {
      const response = await axios.get(
        `${api_url}/insureds/${insuredId}/vehicles`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getInsuredPolicies(insuredId) {
    try {
      const response = await axios.get(
        `${api_url}/insureds/${insuredId}/policies`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getInsuredProposals(insuredId, activatedPolicyNumber, policyType) {
    try {
      const response = await axios.get(
        `${api_url}/insureds/${insuredId}/activated-policies/${activatedPolicyNumber}/policy-type/${policyType}/proposals`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getInsuredCreditCardCharges(
    insuredId,
    activatedPolicyNumber,
    policyType,
  ) {
    try {
      const response = await axios.get(
        `${api_url}/insureds/${insuredId}/activated-policies/${activatedPolicyNumber}/policy-type/${policyType}/credit-cards`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getInsuredBilletCharges(insuredId, activatedPolicyNumber, policyType) {
    try {
      const response = await axios.get(
        `${api_url}/insureds/${insuredId}/activated-policies/${activatedPolicyNumber}/policy-type/${policyType}/billets`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
